/*!
 * VERSION: 1.20.5
 * DATE: 2018-05-21
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 **/
import TweenLite, { _gsScope, TweenPlugin, Ease, Power0, Power1, Power2, Power3, Power4, Linear } from "./TweenLite";
import TimelineLite from "./TimelineLite";
import TimelineMax from "./TimelineMax";
import TweenMax from "./TweenMax";
import CSSPlugin from "./CSSPlugin";
import AttrPlugin from "./AttrPlugin";
import RoundPropsPlugin from "./RoundPropsPlugin";
import DirectionalRotationPlugin from "./DirectionalRotationPlugin";
import BezierPlugin from "./BezierPlugin";
import { Back, Elastic, Bounce, RoughEase, SlowMo, SteppedEase, Circ, Expo, Sine, ExpoScaleEase } from "./EasePack";


export { TweenMax as default };
export { TweenLite, TweenMax, TimelineLite, TimelineMax, CSSPlugin, AttrPlugin, BezierPlugin, RoundPropsPlugin, DirectionalRotationPlugin, TweenPlugin, Ease, Power0, Power1, Power2, Power3, Power4, Linear, Back, Elastic, Bounce, RoughEase, SlowMo, SteppedEase, Circ, Expo, Sine, ExpoScaleEase, _gsScope };



//////////////////
// WEBPACK FOOTER
// ./~/gsap/esm/index.js
// module id = 169
// module chunks = 0